import { FC } from "react";
import { Table } from "@/components/elements/Table";
import { useTable } from "@/hooks/useTable";
import { TCompanyForReportOutputDto } from "@/api/services/main/learning-progress/dtos/get-companies-for-report.dto";
import { useReportColumns } from "@/features/learning-progress/hooks/use-report-columns";
import { Box } from "@mui/material";

type Props = {
  rows: TCompanyForReportOutputDto[];
  isLoading?: boolean;
  onClickCompany: (row: TCompanyForReportOutputDto) => void;
};

export const CompaniesForReportTable: FC<Props> = ({ rows, isLoading, onClickCompany }) => {
  const columns = useReportColumns();

  const handleClickRow = (row: TCompanyForReportOutputDto) => {
    if (row.activeLearnerCount === 0) return;
    onClickCompany(row);
  };

  const { table } = useTable({
    columns,
    rows,
    onClickRow: handleClickRow,
    grayRow: (row) => row.activeLearnerCount === 0,
    disableRow: (row) => row.activeLearnerCount === 0,
    renderEmptyRowsFallback: ({}) => <Box></Box>,
  });

  return <Table table={table} isLoading={isLoading} height={"calc(100vh - 600px)"} minHeight={150} />;
};
